// extracted by mini-css-extract-plugin
export default {"btn":"btn_btn__GVSlC","theme_green":"btn_theme_green__-exsR","theme_light":"btn_theme_light__yXBAa"};